//-- copyright
// OpenProject Resource Planner (multi-resource) management plugin.
// Licensed under the GNU General Public License version 3.
//++

import { Injector, NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OpSharedModule } from 'core-app/shared/shared.module';
import { OpenprojectTabsModule } from 'core-app/shared/components/tabs/openproject-tabs.module';
import {
  WorkPackageTabsService,
} from 'core-app/features/work-packages/components/wp-tabs/services/wp-tabs/wp-tabs.service';
import { registerCustomElement } from 'core-app/shared/helpers/angular/custom-elements.helper';

import { ResourceManagementComponent } from './resource-management/resource-management.component';
import { ResourceUsageComponent } from './resource-usage/resource-usage.component';
import { WpAssignmentsComponent } from './wp-assignments/wp-assignments.component';

export function initializeResourcePlannerPlugin(injector:Injector) {
  const wpTabService = injector.get(WorkPackageTabsService);
  wpTabService.registerBefore(
    'watchers',
    {
      component: WpAssignmentsComponent,
      name: 'Resources',
      id: 'resource-planner',
      displayable: (workPackage) => !!workPackage.resourcePlanner,
    },
  );
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    OpSharedModule,
    OpenprojectTabsModule,
  ],
  declarations: [
    ResourceManagementComponent,
    ResourceUsageComponent,
    WpAssignmentsComponent,
  ],
  exports: [
    ResourceManagementComponent,
    ResourceUsageComponent,
    WpAssignmentsComponent,
  ],
})
export class PluginModule {
  constructor() {
    const injector = inject(Injector);
    initializeResourcePlannerPlugin(injector);
    registerCustomElement('rp-resource-management', ResourceManagementComponent, { injector });
    registerCustomElement('rp-resource-usage', ResourceUsageComponent, { injector });
  }
}
